import { render, staticRenderFns } from "./EventPhoto.vue?vue&type=template&id=459199d0&scoped=true"
import script from "./EventPhoto.vue?vue&type=script&lang=js"
export * from "./EventPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459199d0",
  null
  
)

export default component.exports